module.exports = __webpack_public_path__ + "static/media/photo_024.f545c3cb.JPG";